import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, InputGroup, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../src/asset/css/signIn.css";
import sprintlogo from "../../../src/asset/images/sprintbanner.png";
import { requestResetOtp, confirmPasswordReset } from "../api/resetpassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const NewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const emailFromState = location.state?.email || "";

  const [email, setEmail] = useState(emailFromState);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [timeLeft, setTimeLeft] = useState(() => {
    const savedExpiry = localStorage.getItem("otpExpiry");
    if (savedExpiry) {
      const remaining = Math.floor((new Date(savedExpiry) - new Date()) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    return 120;
  });

  const [canResend, setCanResend] = useState(timeLeft <= 0);

  useEffect(() => {
    if (timeLeft <= 0) {
      setCanResend(true);
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, "0")}:${sec
      .toString()
      .padStart(2, "0")}`;
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   setIsSubmitting(true);

  //   try {
  //     const response = await confirmPasswordReset(email, otp, newPassword);

  //     if (response.status === 200 && response.data?.success) {
  //       alert(response.data?.message || "Password reset successfully!");
  //       navigate("/");
  //     } else {
  //       setError(response.data?.message || "Invalid OTP. Please try again.");
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || "OTP verification failed.");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!newPassword || newPassword.trim() === "") {
      setError("Password is required");
      return;
    }
    setIsSubmitting(true);

    try {
      const response = await confirmPasswordReset(email, otp, newPassword);

      // SUCCESS CASE
      if (response.data.statusCode === 200) {
        toast.success(response.data.message || "Password reset successfully!");
        navigate("/");
        return;
      }

      // EXPIRED OR INVALID OTP
      if (response.data.statusCode === 400) {
        toast.error(" Expired OTP");
        return;
      }

      // OTHER ERRORS
      toast.error("Something went wrong. Please try again.");
    } catch (err) {
      setError(err.response?.data?.message || "Server error. Try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setError("");
      const response = await requestResetOtp(email);
      if (response.status === 200) {
        toast.success(response.data?.message || "OTP resent successfully!");

        const expiryTime = new Date(new Date().getTime() + 120 * 1000);
        localStorage.setItem("otpExpiry", expiryTime);

        setTimeLeft(120);
        setCanResend(false);
      } else {
        setError(response.data?.message || "Failed to resend OTP");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to resend OTP. Please try again."
      );
    }
  };

  return (
    <div className="login-container">
      <Row className="g-0">
        <Col md={6} className="d-none d-md-block">
          <div className="bg_card">
            <div className="mb-2" style={{ textAlign: "center" }}>
              <img src={sprintlogo} alt="Logo" />
            </div>
            <p className="sub_p">
              Manage your educational institution with ease and efficiency.
            </p>
          </div>
        </Col>

        <Col xs={12} md={6}>
          <div className="center-login-card">
            <Card
              className="smooth-shadow-md w-100"
              style={{ maxWidth: "500px" }}
            >
              <Card.Body className="p-4 text-center">
                <div className="mb-3">
                  <i className="bi bi-key" style={{ fontSize: "40px" }}></i>
                </div>
                <h4 className="mb-3">Set New Password</h4>
                <p className="mb-4">
                  Enter the OTP sent to your email and create your new password.
                </p>

         

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="resetEmail">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-envelope-fill"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="resetOtp">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-shield-lock-fill"></i>
                      </InputGroup.Text>
                    
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        disabled={timeLeft <= 0}
                        required
                      />
                    </InputGroup>
                    <div className="text-end mt-1" style={{ fontSize: "14px" }}>
                      {canResend ? (
                        <span
                          style={{ color: "blue", cursor: "pointer" }}
                          onClick={handleResendOtp}
                        >
                          Resend OTP
                        </span>
                      ) : (
                        <span style={{ color: "gray" }}>
                          OTP valid for {formatTime(timeLeft)}
                        </span>
                      )}
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="newPassword">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-lock-fill"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="password"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                   
                      />
                 
                    </InputGroup>
                       {error === "Password is required" && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.875rem",
                            marginTop: "4px",
                          }}
                        >
                          {error}
                        </div>
                      )}
                  </Form.Group>

                  <div className="d-grid mb-3">
                    <Button
                      className="loginButton"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Reset Password"}
                    </Button>
                  </div>

                  <div>
                    <span
                      style={{ cursor: "pointer", color: "blue" }}
                     onClick={() => navigate("/")}
                    >
                      Back to login
                    </span>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default NewPassword;
